import {corePublicApolloClient, throwGQLErrorMessage} from '../../utils/apollo-client';
import { resetPassword as mutation } from '../graphql/reset-password';

export default async function sendResetPasswordEmail(email) {
  const response = await corePublicApolloClient()
    .then((client) =>
      client.mutate({
        mutation,
        variables: { email }
      })
    )
    .catch((error) => {
      if (error.message.indexOf('User not found') > -1) {
        return;
      }
      throwGQLErrorMessage(error);
    });

  return response ? response.data.resetPassword : undefined;
}
